const sections = [
  {
    title: "Information We Collect",
    body: "MekPay may collect identity details, contact information, authentication data, KYC submissions, wallet activity, device information, and transaction records needed to operate financial services safely.",
  },
  {
    title: "How We Use Data",
    body: "User data is used to open and secure accounts, process transactions, detect abuse, meet compliance duties, communicate account updates, and improve service quality.",
  },
  {
    title: "Data Protection",
    body: "We apply technical and operational safeguards to protect personal and financial information from unauthorized access, misuse, or loss.",
  },
  {
    title: "Third-Party Processors",
    body: "Payments, messaging, banking partners, and blockchain infrastructure providers may process limited data required to complete services. Those integrations should be documented and contractually governed.",
  },
  {
    title: "User Rights",
    body: "Users should be able to request account data review, profile updates, and assistance with lawful privacy requests subject to record-keeping obligations that apply to financial products.",
  },
];

export default function PrivacyPage() {
  return (
    <section className="bg-white py-16 md:py-24">
      <div className="mx-auto max-w-4xl px-6">
        <p className="mb-3 text-sm font-semibold uppercase tracking-[0.25em] text-primary">
          Privacy
        </p>
        <h1 className="text-4xl font-bold text-slate-900 md:text-5xl">
          Privacy policy.
        </h1>
        <p className="mt-5 text-lg leading-8 text-slate-600">
          We respect your privacy and explain clearly how your data is collected, used, and protected when you use MekPay.
        </p>

        <div className="mt-12 space-y-8">
          {sections.map((section) => (
            <article key={section.title} className="rounded-3xl border border-slate-200 bg-slate-50 p-7">
              <h2 className="text-2xl font-semibold text-slate-900">{section.title}</h2>
              <p className="mt-3 text-base leading-7 text-slate-600">{section.body}</p>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}